<template>
    <div v-show="visible">
        <div
            v-if="affix"
            v-pendo-affix="affix"
            :style="{
                'background-color': backgroundColor,
                'color': textColor,
            }"
            class="persistent-banner"
            :class="{ 'permanent-shadow': affix['permanent-shadow'] }">
            <div class="persistent-banner__content">
                <slot />
            </div>
        </div>
        <div
            v-if="!affix"
            :style="{
                'background-color': backgroundColor,
                'color': textColor,
            }"
            class="persistent-banner">
            <div class="persistent-banner__content">
                <slot />
            </div>
        </div>
    </div>
</template>

<script>
import { PendoAffix } from '@pendo/components';
import get from 'lodash/get';

export default {
    name: 'PersistentBanner',
    directives: {
        PendoAffix,
    },
    props: {
        affix: {
            type: Object,
            default: () => ({
                shouldAffix: true,
            }),
        },
        backgroundColor: {
            type: String,
            default: 'var(--palette-gray-0)',
        },
        textColor: {
            type: String,
            default: 'var(--palette-gray-110)',
        },
        showOnPublic: {
            type: Boolean,
            default: false,
        },
        showOnGlobalSettings: {
            type: Boolean,
            default: false,
        },
        bannerClosed: {
            type: Boolean,
            default: false,
        },
    },
    computed: {
        visible () {
            const globalSettingsParam = new URL(window.location).searchParams.get('globalSettings');
            const onGlobalSettings = globalSettingsParam === '' || globalSettingsParam === 'true';
            if (onGlobalSettings) {
                return this.showOnGlobalSettings;
            }

            const onPublicPage = get(this, '$route.meta.type') === 'public';
            if (onPublicPage) {
                return this.showOnPublic;
            }
            if (this.bannerClosed) {
                return false;
            }

            return true;
        },
    },
};
</script>

<style scoped lang="less">
.permanent-shadow,
.is-sticky {
    box-shadow: 0 4px 8px var(--semantic-drop-shadow-base);
    border-radius: 0;
    border: 0;
}
.persistent-banner {
    display: flex;
    align-items: center;
    justify-content: center;
    min-height: 72px;
    z-index: 100000;

    &__content {
        display: flex;
        align-items: center;
        width: 100%;
        padding: 10px 32px;
        max-height: 72px;
        overflow-y: auto;
        justify-content: center;
        font-weight: 600;

        a {
            color: inherit;
            text-decoration: none;
        }

        a:hover {
            border-bottom: 1px solid var(--palette-gray-0);
        }
    }
}
</style>
